var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0071 7.5C13.0071 4.46001 10.54 1.99286 7.5 1.99286C4.46001 1.99286 1.99286 4.46001 1.99286 7.5C1.99286 10.54 4.46001 13.0071 7.5 13.0071C10.54 13.0071 13.0071 10.54 13.0071 7.5ZM0.15 7.5C0.15 3.43641 3.43641 0.15 7.5 0.15C11.5636 0.15 14.85 3.43641 14.85 7.5C14.85 11.5636 11.5636 14.85 7.5 14.85C3.43641 14.85 0.15 11.5636 0.15 7.5Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7138 7.28013C11.7138 7.63658 11.4167 7.93371 11.0603 7.93371H4.6317C4.27525 7.93371 3.97813 7.63658 3.97813 7.28013C3.97813 6.92369 4.27525 6.62656 4.6317 6.62656H11.0603C11.4167 6.62656 11.7138 6.92369 11.7138 7.28013Z",
    fill: "#373939",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.e0ba8b53bf5130437ae732c94d990096.svg";
export { ForwardRef as ReactComponent };